<template>
    <div class="md-layout md-gutter">
        <div class="md-layout-item md-size-66">
            <form ref="site_document_public_add" @submit.prevent="addDocument">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="card-icon">
                            <font-awesome-icon class="md-icon" :icon="['fa', 'plus']" />
                        </div>
                        <h4 class="title">Ajout d'un document public</h4>
                    </md-card-header>
                    <document-form :document="document" :errors="errors"></document-form>
                    <md-card-actions md-alignment="left">
                        <md-button type="submit" class="md-success">Enregistrer</md-button>
                        <md-button class="md-warning" @click="goBack">Retour</md-button>
                    </md-card-actions>
                </md-card>
            </form>
        </div>
    </div>
</template>

<script>
// Components
import DocumentForm from "@/pages/Sites/Documents/components/DocumentForm";

export default {
    name: "DocumentPublicAdd",
    components: {
        DocumentForm
    },
    data() {
        return {
            document: {
                name: '',
                type: 0,
                file: null
            },
            errors: []
        }
    },
    methods: {
        async addDocument() {
            if(this.document.file) {
                let formData = new FormData()
                formData.append('file', this.document.file)
                formData.append('fileName', this.formatFileName(this.document.file))
                formData.append('name', this.document.name)
                try {
                    this.errors = [];
                    const { data } = await this.$store.dispatch('site_documents/uploadSiteDocument', formData)
                    let pathParts = data.split('/')
                    let document = {
                        name: this.document.name,
                        type: this.document.type,
                        filePath: pathParts[4],
                        siteId: parseInt(this.$route.params.idSite)
                    }
                    await this.$store.dispatch('site_documents/addSiteDocument', document)
                    await this.$store.dispatch("alerts/success", "Document public ajouté")
                    this.goBack()
                } catch (e) {
                    this.errors = e.response.data.errors
                }
            } else {
                this.errors = [{
                    detail: 'Le fichier est requis.',
                    source: { pointer: '/data/attributes/file' }
                }]
            }
        },
        formatFileName(file) {
            let regex = /[ ]|'/g // search space and apostrophe
            return Math.floor(Math.random() * (9999 - 1000 + 1) + 1000) + '-' +
                file.name.toLowerCase().replaceAll(regex, '-')
        },
        goBack() {
            this.$router.go(-1)
        }
    }
}
</script>

<style scoped>

</style>
